import type { MonospaceBlock } from '#layers/data-model/types/schema/resolved-schema';
import * as z from 'zod/v4-mini';
import { RStoreSchema } from '#imports';

export const Block = RStoreSchema.withItemType<MonospaceBlock>().defineCollection({
	name: 'MonospaceBlock',
	formSchema: {
		create: z.object({
			name: z.string().check(z.minLength(1)),
		}),
		update: z.object({
			name: z.string().check(z.minLength(1)),
			icon: z.string(),
			description: z.string(),
			category: z.string(),
		}),
	},
	meta: {
		defaultFields: ['id', 'name', 'icon', 'description', 'category', 'renderData', 'spaceId', 'pageId'],
		useProjectSlug: true,
		connect: {
			collectionId: ['collection', 'id'],
			pageId: ['page', 'id'],
		},
	},
});
